import {
  ALLOCATION_TYPES,
  DAY_TYPE,
  ERSETariffsTypes,
  SEASONS_TYPES,
  ciclesTypes,
  contractTypes,
  periods,
  resourceTypes,
  userRoles,
  voltageLevelTypes,
} from "utils/constants/index";
import { enumLabel } from "utils/constants/enumLabels";
import { MONTHS } from "utils/constants/time";

const getLabelFromValue = (array, value, group) => {
  const label = array.filter((type) => type.value === value)[0]?.label;
  return label !== undefined && group ? enumLabel(group, value, label) : label;
};
const getValueFromLabel = (array, label) => array.filter((type) => type.label === label)[0]?.value;

export const getCiclesTypeLabelFromValue = (value) =>
  getLabelFromValue(ciclesTypes, value, "ciclesType");

export const getContractTypeLabelFromValue = (value) =>
  getLabelFromValue(contractTypes, value, "contractType");

export const getPeriodLabelFromValue = (value) => getLabelFromValue(periods, value, "period");

export const getERSETypeLabelFromValue = (value) =>
  getLabelFromValue(ERSETariffsTypes, value, "erseTariffType");

export const getResourceTypeLabelFromValue = (value) =>
  getLabelFromValue(resourceTypes, value, "resourceType");

export const getAllocationTypeLabelFromValue = (value) =>
  getLabelFromValue(ALLOCATION_TYPES, value, "allocation");

export const getUserRoleLabelFromValue = (value) => getLabelFromValue(userRoles, value, "userRole");

export const getVoltageLevelLabelFromValue = (value) =>
  getLabelFromValue(voltageLevelTypes, value, "voltageLevel");

export const getSeasonLabelFromValue = (value) => getLabelFromValue(SEASONS_TYPES, value);

export const getDayTypeLabelFromValue = (value) => getLabelFromValue(DAY_TYPE, value);

export const getMonthLabelFromValue = (value) => getLabelFromValue(MONTHS, value);

export default {
  getCiclesTypeLabelFromValue,
  getContractTypeLabelFromValue,
  getERSETypeLabelFromValue,
  getResourceTypeLabelFromValue,
  getAllocationTypeLabelFromValue,
  getVoltageLevelLabelFromValue,
  getValueFromLabel,
  getMonthLabelFromValue,
};
